module.exports = __webpack_public_path__ + "static/media/placeholder.e3bda11a.svg";